var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThreeDots(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 4,
    viewBox: "0 0 16 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.83333 2.00001C3.83333 2.92049 3.08714 3.66668 2.16667 3.66668C1.24619 3.66668 0.5 2.92049 0.5 2.00001C0.5 1.07954 1.24619 0.333344 2.16667 0.333344C3.08714 0.333344 3.83333 1.07954 3.83333 2.00001Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.66667 2.00001C9.66667 2.92049 8.92047 3.66668 8 3.66668C7.07953 3.66668 6.33333 2.92049 6.33333 2.00001C6.33333 1.07954 7.07953 0.333344 8 0.333344C8.92047 0.333344 9.66667 1.07954 9.66667 2.00001Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 2.00001C15.5 2.92049 14.7538 3.66668 13.8333 3.66668C12.9129 3.66668 12.1667 2.92049 12.1667 2.00001C12.1667 1.07954 12.9129 0.333344 13.8333 0.333344C14.7538 0.333344 15.5 1.07954 15.5 2.00001Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDots);
export default __webpack_public_path__ + "static/media/three_dots.a8ea5c25a05f0bd09816621dc075654d.svg";
export { ForwardRef as ReactComponent };